export const userProfileImage = (state) => state.userProfileImage;

export const userDataDetails = (state) => state.userData;

export const notificationsSettings = (state) => state.notificationsSettings;

export const getUserId = (state) => state.userId;

export const getNeedsTaskRedirect = (state) => state.needsTaskRedirect;

export const getDelegationId = (state) => state.delegationId;

export const getUserIsManager = (state) => state.userIsManager;

export const userProfileDDLs = (state) => state.userProfileDDLs;

export const getUserEmail = (state) => state.userEmail;

export const getUserName = (state) => state.userName;

export const myRoles = (state) => state.myRoles;

export const userCookieInfo = (state) => state.userCookieInfo;

export const timestampCookie = (state) => state.timestampCookie;

export const getUserListDelegation = (state) => state.userListDelegation;
